import FilterStories from 'app/components/partials/filter-stories.container';
import PropTypes from 'prop-types';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { getCategoryFilters, getPageNumber, LAYOUT, resolveCategories } from 'app/utilities/news-listing';

/*
    The news listing as a content block, on whichever page the CMS puts it,
    filtered by the categories the block itself names. With nothing ticked it
    lists every category, as the news landing page does, rather than being tied
    to a category of its own.

    It takes the shape a category page's listing does rather than the landing
    page's: cards in a grid the reader adds to, on the page itself, with the
    filter block the only thing in grey. A block sits among the other blocks of a
    page, so it reads as part of the page rather than as a band across it.

    Which page of the listing is on screen is read from the URL here rather than
    handed down through the templates, because the block can appear on any of
    them and the listing state belongs to the URL either way. The listing itself
    is one piece of store state, so one of these to a page.
*/
const FilterStoriesBlock = ({ categories = [], title }) => {
    const { search } = useLocation();
    // Unknown slugs are dropped and the rest put in the order the block lists
    // them, so a mistyped or reordered query cannot make a listing of its own
    const activeCategories = resolveCategories(categories, getCategoryFilters(search))
        .map((category) => category.slug);

    return (
        <FilterStories
            activeCategories={activeCategories}
            categories={categories}
            layout={LAYOUT.GRID}
            listingPage={getPageNumber(search)}
            title={title} />
    );
};

FilterStoriesBlock.propTypes = {
    categories: PropTypes.array,
    title: PropTypes.string
};

export default FilterStoriesBlock;
